

















import {Component, Prop, Vue} from "vue-property-decorator";
import {RoleStore} from "@/modules/roles/store";
import {Role} from "@/interfaces/entity";

@Component({
    name: "RoleTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly roleId!: number;

    get role(): Role {
        return RoleStore.data[this.roleId];
    }
    
    async onConfirm() {
        try {
            await RoleStore.deleteRole(this.roleId);
            this.$message.success({
                content: "Xóa nhóm quyền thành công"
            });
        } catch (e) {
            this.$message.error({
                content: "Xóa nhóm quyền thất bại"
            });
        }
    }
}
